export default "__VITE_ASSET__fr_pgGa0__"